<template>
  <v-card
    class="mb-6"
    variant="outlined"
  >
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-row>
            <v-col>
              <div class="field-with-top-label">
                <div class="field-top-label">
                  ユーザーID
                </div>
                <v-text-field
                  v-model="userId"
                  type="text"
                  density="compact"
                  variant="outlined"
                  hide-details
                />
              </div>
            </v-col>
            <v-col md="6">
              <div class="d-flex">
                <div class="field-with-top-label joined-name-field">
                  <div class="field-top-label">
                    セイ
                  </div>
                  <v-text-field
                    v-model="familyNameKana"
                    density="compact"
                    variant="outlined"
                    class="joined-name-field-left"
                    hide-details
                  />
                </div>
                <div class="field-with-top-label joined-name-field">
                  <div class="field-top-label">
                    メイ
                  </div>
                  <v-text-field
                    v-model="firstNameKana"
                    density="compact"
                    variant="outlined"
                    class="joined-name-field-right"
                    hide-details
                  />
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <div class="field-with-top-label">
                <div class="field-top-label">
                  郵便番号(前方一致)
                </div>
                <v-text-field
                  v-model="postalCode"
                  density="compact"
                  variant="outlined"
                  hide-details
                />
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <div class="field-with-top-label">
                <div class="field-top-label">
                  クーポン名
                </div>
                <v-autocomplete
                  v-model="couponName"
                  :items="couponNameOptions"
                  placeholder="未設定"
                  density="compact"
                  variant="outlined"
                  clearable
                  hide-details
                />
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <div class="field-with-top-label">
                <div class="field-top-label">
                  ユーザーの生年月日
                </div>
                <v-menu
                  v-model="isUserBirthdayPickerOpen"
                  :close-on-content-click="false"
                  location="bottom start"
                >
                  <template #activator="{ props: menuProps }">
                    <div class="date-input-wrapper">
                      <input
                        :value="userBirthday"
                        v-bind="menuProps"
                        class="date-input"
                        type="text"
                        readonly
                      >
                      <v-icon
                        class="date-input-icon"
                        icon="mdi-calendar"
                        size="small"
                      />
                    </div>
                  </template>
                  <VueDatePicker
                    v-model="userBirthday"
                    locale="ja"
                    format="yyyy-MM-dd"
                    model-type="yyyy-MM-dd"
                    :enable-time-picker="false"
                    :clearable="true"
                    inline
                    @update:model-value="isUserBirthdayPickerOpen = false"
                  />
                </v-menu>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <div class="field-with-top-label">
                <div class="field-top-label">
                  子の生年月日
                </div>
                <v-menu
                  v-model="isChildBirthdayPickerOpen"
                  :close-on-content-click="false"
                  location="bottom start"
                >
                  <template #activator="{ props: menuProps }">
                    <div class="date-input-wrapper">
                      <input
                        :value="childBirthday"
                        v-bind="menuProps"
                        class="date-input"
                        type="text"
                        readonly
                      >
                      <v-icon
                        class="date-input-icon"
                        icon="mdi-calendar"
                        size="small"
                      />
                    </div>
                  </template>
                  <VueDatePicker
                    v-model="childBirthday"
                    locale="ja"
                    format="yyyy-MM-dd"
                    model-type="yyyy-MM-dd"
                    :enable-time-picker="false"
                    :clearable="true"
                    inline
                    @update:model-value="isChildBirthdayPickerOpen = false"
                  />
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-row>
            <v-col md="3">
              <div class="checkbox-list-label">
                ステータス
              </div>
              <div
                v-for="status in statusOptions"
                :key="status"
                class="option-chip"
                :class="statusChipClass(status)"
              >
                <v-checkbox
                  v-model="statuses"
                  :label="status"
                  :value="status"
                  :color="statusChipColor(status)"
                  density="compact"
                  hide-details
                />
              </div>
            </v-col>
            <v-col md="3">
              <div class="checkbox-list-label">
                未対応アラート
              </div>
              <div
                v-for="alert in unhandledAlertOptions"
                :key="alert"
                class="option-chip option-chip--teal"
                :class="{ 'option-chip--checked': unhandledAlerts.includes(alert) }"
              >
                <v-checkbox
                  v-model="unhandledAlerts"
                  :label="alert"
                  :value="alert"
                  color="#2CB5AE"
                  density="compact"
                  hide-details
                />
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <div class="checkbox-list-label">
                履歴条件
              </div>
              <v-row
                dense
                class="history-condition-list"
              >
                <v-col
                  v-for="historyCondition in historyConditionOptions"
                  :key="historyCondition"
                  cols="12"
                  md="6"
                  class="history-condition-item"
                >
                  <div
                    class="option-chip option-chip--teal"
                    :class="{ 'option-chip--checked': historyConditions.includes(historyCondition) }"
                  >
                    <v-checkbox
                      v-model="historyConditions"
                      :label="historyCondition"
                      :value="historyCondition"
                      color="#2CB5AE"
                      density="compact"
                      hide-details
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <div class="d-flex align-center">
        <v-btn
          color="#3ACAC9"
          class="mr-2 search-button"
          :loading="isSearching"
          :disabled="isSearching"
          @click="$emit('search')"
        >
          検索
        </v-btn>
        <v-btn
          color="#9E9E9E"
          class="clear-button"
          @click="$emit('clear')"
        >
          クリア
        </v-btn>
        <span
          v-if="isSearching"
          class="ml-3 searching-label"
        >
          検索を実行しています
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FaceSheetSearchForm",
  props: {
    searchForm: {
      type: Object,
      required: true
    },
    couponNameOptions: {
      type: Array,
      required: true
    },
    statusOptions: {
      type: Array,
      required: true
    },
    unhandledAlertOptions: {
      type: Array,
      required: true
    },
    historyConditionOptions: {
      type: Array,
      required: true
    },
    isSearching: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:searchForm", "search", "clear"],
  data() {
    return {
      isUserBirthdayPickerOpen: false,
      isChildBirthdayPickerOpen: false
    };
  },
  computed: {
    userId: {
      get() {
        return this.searchForm.userId;
      },
      set(value) {
        this.updateSearchForm("userId", value);
      }
    },
    familyNameKana: {
      get() {
        return this.searchForm.familyNameKana;
      },
      set(value) {
        this.updateSearchForm("familyNameKana", value);
      }
    },
    firstNameKana: {
      get() {
        return this.searchForm.firstNameKana;
      },
      set(value) {
        this.updateSearchForm("firstNameKana", value);
      }
    },
    postalCode: {
      get() {
        return this.searchForm.postalCode;
      },
      set(value) {
        this.updateSearchForm("postalCode", value);
      }
    },
    couponName: {
      get() {
        return this.searchForm.couponName;
      },
      set(value) {
        this.updateSearchForm("couponName", value);
      }
    },
    userBirthday: {
      get() {
        return this.searchForm.userBirthday;
      },
      set(value) {
        this.updateSearchForm("userBirthday", value);
      }
    },
    childBirthday: {
      get() {
        return this.searchForm.childBirthday;
      },
      set(value) {
        this.updateSearchForm("childBirthday", value);
      }
    },
    statuses: {
      get() {
        return this.searchForm.statuses;
      },
      set(value) {
        this.updateSearchForm("statuses", value);
      }
    },
    unhandledAlerts: {
      get() {
        return this.searchForm.unhandledAlerts;
      },
      set(value) {
        this.updateSearchForm("unhandledAlerts", value);
      }
    },
    historyConditions: {
      get() {
        return this.searchForm.historyConditions;
      },
      set(value) {
        this.updateSearchForm("historyConditions", value);
      }
    }
  },
  methods: {
    updateSearchForm(key, value) {
      this.$emit("update:searchForm", {
        ...this.searchForm,
        [key]: Array.isArray(value) ? [...value] : value
      });
    },
    statusChipClass(status) {
      if (status === "要対応") {
        return {
          "option-chip--red": true,
          "option-chip--checked": this.statuses.includes(status)
        };
      }
      if (status === "要注意観察中") {
        return {
          "option-chip--orange": true,
          "option-chip--checked": this.statuses.includes(status)
        };
      }
      return {
        "option-chip--checked": this.statuses.includes(status)
      };
    },
    statusChipColor(status) {
      if (status === "要対応") {
        return "#E2536B";
      }
      if (status === "要注意観察中") {
        return "#F0932B";
      }
      return undefined;
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-list-label {
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 4px;
}

:deep(.v-checkbox .v-label) {
  font-size: 0.75rem;
}

:deep(.v-checkbox .v-selection-control) {
  min-height: 28px;
}

.option-chip {
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  margin-bottom: 4px;
  padding: 0 8px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.option-chip--checked.option-chip--red {
  background-color: #fbdfe2;
  border-color: #f3b7bf;
}

.option-chip--checked.option-chip--orange {
  background-color: #fde3cc;
  border-color: #f6c68f;
}

.option-chip--checked.option-chip--teal {
  background-color: #d3efee;
  border-color: #a3ded9;
}

.option-chip--checked:not(.option-chip--red):not(.option-chip--orange):not(.option-chip--teal) {
  background-color: #eeeeee;
  border-color: #d0d0d0;
}

.history-condition-item {
  padding-top: 0;
  padding-bottom: 0;
}

.history-condition-list :deep(.v-checkbox .v-selection-control) {
  min-height: 24px;
}

.joined-name-field {
  flex: 1 1 0;
}

.no-native-date-placeholder :deep(input[type="date"]:placeholder-shown) {
  color: transparent;
}

.date-input-wrapper {
  position: relative;
  width: 100%;
}

.date-input {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  font-size: 0.875rem;
  height: 36px;
  line-height: 1.5;
  min-width: 130px;
  padding: 0 30px 0 8px;
  width: 100%;
}

.date-input-icon {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.54);
  pointer-events: none;
}

.field-with-top-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-top-label {
  color: rgba(0, 0, 0, 0.72);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  margin-left: 4px;
}

.joined-name-field-left :deep(.v-field) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.joined-name-field-right :deep(.v-field) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.search-button,
.clear-button {
  color: #fff !important;
}

.searching-label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
}
</style>
